var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("boards-tab-loader")
    : _c(
        "div",
        { attrs: { id: "boards-settings-container" } },
        [
          _c(
            "b-card",
            {
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("settings.boardsTab.defaultStatusTitle")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("icon", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t("settings.boardsTab.titleTooltip"),
                            },
                            expression:
                              "{\n          title: $t('settings.boardsTab.titleTooltip')\n        }",
                          },
                        ],
                        staticClass: "ml-1 clickable text-primary",
                        attrs: { name: "info-circle" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "b-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-end" },
                    [
                      _c("b-col", [
                        _c("p", {
                          staticStyle: { "white-space": "pre-line" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("settings.boardsTab.defaultStatusMessage")
                            ),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  options: _vm.languageOptions,
                                  "button-variant": "outline-primary",
                                  name: "radios-btn-default",
                                  buttons: "",
                                },
                                model: {
                                  value: _vm.localBrokerageBoards.displayFrench,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localBrokerageBoards,
                                      "displayFrench",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "localBrokerageBoards.displayFrench",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("list-component", {
                        attrs: {
                          list: _vm.localBrokerageBoards.statuses[
                            _vm.displayLocale
                          ],
                        },
                        on: { input: _vm.updateStatuses },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }